import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { InviteFormData } from '../components/recognition/bonus/components/invite/invite-form';

export interface SendInviteAPIData {
	recipient_user_ids: string[];
	bonus_id: string;
	subject: string;
	headline: string;
	body: string;
}

export interface InviteBatchResponse {
	id: string;
	status: 'pending' | 'processing' | 'completed' | 'failed';
	total_recipients: number;
	bonus_id: string;
	recipient_user_ids: string[];
	created_at: string;
	completed_at: string | null;
	email: {
		subject: string;
		headline: string;
		body: string;
	};
}

export interface MutateInviteOptions {
	onMutate?: () => void;
	onSuccess?: (data: InviteBatchResponse) => void;
	onError?: (error: any) => void;
}

export const useSendInvites = (options: MutateInviteOptions = {}) => {
	const http = useHttpClient();

	return useMutation({
		mutationFn: async (data: { formData: InviteFormData; bonusId: string }) => {
			options.onMutate?.();

			try {
				const payload: SendInviteAPIData = {
					recipient_user_ids: data.formData.inviteList.map((user) => user.id),
					bonus_id: data.bonusId,
					subject: data.formData.subject,
					headline: data.formData.title,
					body: data.formData.body,
				};

				const res = await http.post<InviteBatchResponse>('/invites', payload);
				options.onSuccess?.(res.data);
				return res.data;
			} catch (e) {
				options.onError?.(e);
				throw e;
			}
		},
	});
};
